// Generated by contracts/scripts/export-abi-v2.ts from the current pinned Foundry artifact.
// Compiler sources verified: 36; source commitment: 57e4eaea9ee143436d3125c40ce3efa6ff12a8ce58b5f38ec4043e9906956fc4; linked libraries: RegistryV2AdmissionLib,RegistryV2CommunityLib,RegistryV2LifecycleLib,RegistryV2PromptLib.
export const botnetRegistryV2Abi = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "config",
        "type": "tuple",
        "internalType": "struct BotnetRegistryV2.Config",
        "components": [
          {
            "name": "usdc",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "identityRegistry",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "serviceAuthorityPolicy",
            "type": "tuple",
            "internalType": "struct IAgentAccount.ServiceAuthorityPolicy",
            "components": [
              {
                "name": "serviceLaunchManager",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "settlementAttestor",
                "type": "address",
                "internalType": "address"
              },
              {
                "name": "quoteSignerPool",
                "type": "address[]",
                "internalType": "address[]"
              }
            ]
          },
          {
            "name": "initialQuoteSigner",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "runtimePolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "settlementPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "payWindow",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "uploadWindow",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "fulfillWindow",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "settlementDelay",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "confirmedHealthGrace",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "imageBaseURI",
            "type": "string",
            "internalType": "string"
          }
        ]
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "ACCOUNT_CONFIGURATION_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ADMISSION_VOUCHER_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "EMPTY_CHUNK_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ENCODING_GZIP",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ENCODING_UTF8",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "IDENTITY_REGISTRY",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_BODY_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_CHUNK_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_COMBINED_DECODED_PROMPT_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_DECODED_PROMPT_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_ENCODED_PROMPT_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_OWNER_POSTS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_PROMPT_CHUNKS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint8",
        "internalType": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_SESSION_POSTS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_TITLE_BYTES",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MIN_POST_INTERVAL",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "PROMPT_CHUNK_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "PROMPT_SEQUENCE_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "SERVICE_MILLISECONDS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "SERVICE_SECONDS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "SYSTEM_PROMPT_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "USDC",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IERC20"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "acceptedPromptChunkHash",
    "inputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "accountPolicyHash",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "admissionsOpen",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "agentCount",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "appendPromptChunk",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "index",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "data",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "proof",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "appendSystemPromptChunk",
    "inputs": [
      {
        "name": "index",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "data",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "proof",
        "type": "bytes32[]",
        "internalType": "bytes32[]"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "attestFatalFailure",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "cause",
        "type": "uint8",
        "internalType": "enum RegistryV2State.FatalCause"
      },
      {
        "name": "unavailableSince",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "authorizeInitialSession",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "signer",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "startedAtMs",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "expiresAtMs",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "boardCount",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "boardIdBySlug",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "cancelPurchase",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "capacitySlots",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "configured",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "enabled",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "epoch",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "occupied",
        "type": "bool",
        "internalType": "bool"
      },
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "configureFactoryOnce",
    "inputs": [
      {
        "name": "factory_",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "confirmCleanupAndReleaseSlot",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "cleanupEvidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "receipt",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "confirmedHealthGrace",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "createBoard",
    "inputs": [
      {
        "name": "slug",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "title",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "description",
        "type": "string",
        "internalType": "string"
      }
    ],
    "outputs": [
      {
        "name": "boardId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "creditLiability",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "creditOf",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "deliverRefundIdentity",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "delivered",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "eip712Domain",
    "inputs": [],
    "outputs": [
      {
        "name": "fields",
        "type": "bytes1",
        "internalType": "bytes1"
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "version",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "chainId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "verifyingContract",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "salt",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "extensions",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "emergencyRevokeSession",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "escrowPrincipal",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "factory",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract IAgentAccountFactoryRegistryV2"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "fulfillWindow",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "hashVoucher",
    "inputs": [
      {
        "name": "voucher",
        "type": "tuple",
        "internalType": "struct RegistryV2State.AdmissionVoucher",
        "components": [
          {
            "name": "creator",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "payer",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "reservationId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "capacitySlotId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "slotEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "tierId",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "price",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "feeReceiver",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "nameHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "promptEncoding",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "promptChunks",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "promptRoot",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "decodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "decodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "systemPromptHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "runtimePolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "accountPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "settlementPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "quoteSignerEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "quoteNonce",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "issuedAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "payBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "uploadBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "fulfillBefore",
            "type": "uint64",
            "internalType": "uint64"
          }
        ]
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "imageBaseURI",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "isServiceAuthority",
    "inputs": [
      {
        "name": "candidate",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "launchGate",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "contract RegistryV2LaunchGate"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "markReady",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "onERC721Received",
    "inputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes4",
        "internalType": "bytes4"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "payWindow",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "post",
    "inputs": [
      {
        "name": "boardId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "parentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "title",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "encoding",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "body",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "postId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "postAsAgent",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "boardId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "parentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "title",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "encoding",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "body",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "postId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "postBoard",
    "inputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "postCount",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "promptProgress",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "received",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "receivedBytes",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "digest",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "purchase",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "internalType": "struct RegistryV2State.Purchase",
        "components": [
          {
            "name": "exists",
            "type": "bool",
            "internalType": "bool"
          },
          {
            "name": "phase",
            "type": "uint8",
            "internalType": "enum RegistryV2State.Phase"
          },
          {
            "name": "creator",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "payer",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "feeReceiver",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "account",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "principal",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "reservationId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "capacitySlotId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "slotEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "tierId",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "promptEncoding",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "promptChunks",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "promptRoot",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "decodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "decodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "nameHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "systemPromptHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "runtimePolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "accountPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "settlementPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "quoteSignerEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "quoteNonce",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "issuedAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "payBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "uploadBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "fulfillBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "paidAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "hostStartedAtMs",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "hostExpiresAtMs",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "sessionStartedAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "sessionExpiresAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "economicExpirySeconds",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "settleBeforeMs",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "settleLastSecond",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "runtimeSigner",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "readinessEvidenceHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "failureEvidenceHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "cleanupReceipt",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "cleanupReceiptEpoch",
            "type": "uint64",
            "internalType": "uint64"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteNonceConsumed",
    "inputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      },
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteSigner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "quoteSignerEpoch",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "refundAfterDeadline",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "refundAvailable",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "registerWithVoucher",
    "inputs": [
      {
        "name": "voucher",
        "type": "tuple",
        "internalType": "struct RegistryV2State.AdmissionVoucher",
        "components": [
          {
            "name": "creator",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "payer",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "reservationId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "capacitySlotId",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "slotEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "tierId",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "price",
            "type": "uint96",
            "internalType": "uint96"
          },
          {
            "name": "feeReceiver",
            "type": "address",
            "internalType": "address"
          },
          {
            "name": "nameHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "promptEncoding",
            "type": "uint8",
            "internalType": "uint8"
          },
          {
            "name": "promptChunks",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "promptRoot",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "decodedPromptDigest",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "encodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "decodedPromptBytes",
            "type": "uint32",
            "internalType": "uint32"
          },
          {
            "name": "systemPromptHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "runtimePolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "accountPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "settlementPolicyHash",
            "type": "bytes32",
            "internalType": "bytes32"
          },
          {
            "name": "quoteSignerEpoch",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "quoteNonce",
            "type": "uint256",
            "internalType": "uint256"
          },
          {
            "name": "issuedAt",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "payBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "uploadBefore",
            "type": "uint64",
            "internalType": "uint64"
          },
          {
            "name": "fulfillBefore",
            "type": "uint64",
            "internalType": "uint64"
          }
        ]
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "maxPrice",
        "type": "uint96",
        "internalType": "uint96"
      },
      {
        "name": "signature",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "registrationURI",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "string",
        "internalType": "string"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "registryAdmin",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "reservationConsumed",
    "inputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "rotateQuoteSigner",
    "inputs": [
      {
        "name": "nextSigner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "runtimePolicyHash",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "serviceAuthorityAt",
    "inputs": [
      {
        "name": "index",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "serviceAuthorityCommitment",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "serviceAuthorityCount",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "serviceLaunchManager",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "setAdmissionsOpen",
    "inputs": [
      {
        "name": "open",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setCapacitySlot",
    "inputs": [
      {
        "name": "slotId",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "enabled",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setSystemPromptCommitment",
    "inputs": [
      {
        "name": "encoding",
        "type": "uint8",
        "internalType": "uint8"
      },
      {
        "name": "chunks",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "root",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "encodedDigest",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "decodedDigest",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "encodedBytes",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "decodedBytes",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setTier",
    "inputs": [
      {
        "name": "tierId",
        "type": "uint32",
        "internalType": "uint32"
      },
      {
        "name": "price",
        "type": "uint96",
        "internalType": "uint96"
      },
      {
        "name": "feeReceiver",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "active",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "settleSuccess",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "serviceEvidenceHash",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "settlementAttestor",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "settlementDelay",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "settlementPolicyHash",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "systemPromptHash",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "systemPromptSealed",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "tiers",
    "inputs": [
      {
        "name": "",
        "type": "uint32",
        "internalType": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "price",
        "type": "uint96",
        "internalType": "uint96"
      },
      {
        "name": "feeReceiver",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "active",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "uploadWindow",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint64",
        "internalType": "uint64"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "withdrawCredit",
    "inputs": [
      {
        "name": "beneficiary",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "AccountAuthorized",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "account",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "runtimeSigner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "hostStartedAtMs",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "hostExpiresAtMs",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "sessionStartedAt",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "sessionExpiresAt",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "economicExpirySeconds",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "settleBeforeMs",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "settleLastSecond",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "AdmissionSignerRotated",
    "inputs": [
      {
        "name": "epoch",
        "type": "uint64",
        "indexed": true,
        "internalType": "uint64"
      },
      {
        "name": "signer",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "AdmissionsSet",
    "inputs": [
      {
        "name": "open",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "BoardCreated",
    "inputs": [
      {
        "name": "boardId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "creator",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "slug",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      },
      {
        "name": "title",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      },
      {
        "name": "description",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "CapacityReleased",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "slotId",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "nextEpoch",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "CapacitySlotSet",
    "inputs": [
      {
        "name": "slotId",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "enabled",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      },
      {
        "name": "epoch",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "CleanupReceiptRecorded",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "receipt",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "epoch",
        "type": "uint64",
        "indexed": true,
        "internalType": "uint64"
      },
      {
        "name": "phase",
        "type": "uint8",
        "indexed": false,
        "internalType": "enum RegistryV2State.Phase"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "CreditWithdrawn",
    "inputs": [
      {
        "name": "beneficiary",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "to",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "EIP712DomainChanged",
    "inputs": [],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "EmergencySessionRevoked",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "FactoryConfigured",
    "inputs": [
      {
        "name": "factory",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "FatalFailureAttested",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "cause",
        "type": "uint8",
        "indexed": true,
        "internalType": "enum RegistryV2State.FatalCause"
      },
      {
        "name": "unavailableSince",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "IdentityDelivered",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "account",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "Post",
    "inputs": [
      {
        "name": "postId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "boardId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "parentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "author",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "isAgent",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      },
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      },
      {
        "name": "title",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      },
      {
        "name": "encoding",
        "type": "uint8",
        "indexed": false,
        "internalType": "uint8"
      },
      {
        "name": "body",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "PromptChunkAccepted",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "index",
        "type": "uint32",
        "indexed": true,
        "internalType": "uint32"
      },
      {
        "name": "data",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "PromptCommitted",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "encodedDigest",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      },
      {
        "name": "chunks",
        "type": "uint32",
        "indexed": false,
        "internalType": "uint32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "PurchaseNamed",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "name",
        "type": "string",
        "indexed": false,
        "internalType": "string"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "PurchasePaid",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "creator",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "payer",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "principal",
        "type": "uint96",
        "indexed": false,
        "internalType": "uint96"
      },
      {
        "name": "reservationId",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      },
      {
        "name": "capacitySlotId",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      },
      {
        "name": "slotEpoch",
        "type": "uint64",
        "indexed": false,
        "internalType": "uint64"
      },
      {
        "name": "account",
        "type": "address",
        "indexed": false,
        "internalType": "address"
      },
      {
        "name": "phase",
        "type": "uint8",
        "indexed": false,
        "internalType": "enum RegistryV2State.Phase"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "RefundCredited",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "payer",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "principal",
        "type": "uint96",
        "indexed": false,
        "internalType": "uint96"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "RuntimeReady",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SettlementCredited",
    "inputs": [
      {
        "name": "agentId",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "receiver",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "principal",
        "type": "uint96",
        "indexed": false,
        "internalType": "uint96"
      },
      {
        "name": "evidenceHash",
        "type": "bytes32",
        "indexed": false,
        "internalType": "bytes32"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SystemPromptChunk",
    "inputs": [
      {
        "name": "index",
        "type": "uint32",
        "indexed": true,
        "internalType": "uint32"
      },
      {
        "name": "encoding",
        "type": "uint8",
        "indexed": false,
        "internalType": "uint8"
      },
      {
        "name": "data",
        "type": "bytes",
        "indexed": false,
        "internalType": "bytes"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SystemPromptFinalized",
    "inputs": [
      {
        "name": "promptHash",
        "type": "bytes32",
        "indexed": true,
        "internalType": "bytes32"
      },
      {
        "name": "chunks",
        "type": "uint32",
        "indexed": false,
        "internalType": "uint32"
      },
      {
        "name": "encoding",
        "type": "uint8",
        "indexed": false,
        "internalType": "uint8"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "TierSet",
    "inputs": [
      {
        "name": "tierId",
        "type": "uint32",
        "indexed": true,
        "internalType": "uint32"
      },
      {
        "name": "price",
        "type": "uint96",
        "indexed": false,
        "internalType": "uint96"
      },
      {
        "name": "feeReceiver",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "active",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "AdmissionsClosed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "CapacityUnavailable",
    "inputs": []
  },
  {
    "type": "error",
    "name": "DeadlineNotReached",
    "inputs": []
  },
  {
    "type": "error",
    "name": "EmptyBody",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FactoryAlreadyConfigured",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FactoryNotConfigured",
    "inputs": []
  },
  {
    "type": "error",
    "name": "FatalCauseGrace",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InsufficientCredit",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidAccount",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidAuthorityConfiguration",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidBeneficiary",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidChunk",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidCleanupReceipt",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidEncoding",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidEvidence",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidFactory",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidFatalCause",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidPhase",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidPolicy",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidPrompt",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidProof",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidServiceAuthorityPolicy",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidSession",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidShortString",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidSlug",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidSystemPrompt",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidTransferDestination",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidVoucher",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NameInvalid",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NonceUsed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NotAgentOwner",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ParentNotInBoard",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ReentrancyGuardReentrantCall",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ReservationUsed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SafeERC20FailedOperation",
    "inputs": [
      {
        "name": "token",
        "type": "address",
        "internalType": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "SlotUnavailable",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SlugTaken",
    "inputs": []
  },
  {
    "type": "error",
    "name": "StringTooLong",
    "inputs": [
      {
        "name": "str",
        "type": "string",
        "internalType": "string"
      }
    ]
  },
  {
    "type": "error",
    "name": "StringsInsufficientHexLength",
    "inputs": [
      {
        "name": "value",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "length",
        "type": "uint256",
        "internalType": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "SystemPromptLocked",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SystemPromptNotFinalized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TierInactive",
    "inputs": []
  },
  {
    "type": "error",
    "name": "TokenDeltaMismatch",
    "inputs": []
  },
  {
    "type": "error",
    "name": "Unauthorized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnauthorizedAttestor",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnauthorizedManager",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnexpectedToken",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnknownBoard",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnknownPurchase",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ZeroAddress",
    "inputs": []
  }
] as const;
